module.exports = __webpack_public_path__ + "static/media/support.bd1f6ca3.svg";